import React from "react";
import { Clock } from "lucide-react";
import { useLang } from "../../context/LanguageContext";

const DAY_KEYS = ["pd.mon", "pd.tue", "pd.wed", "pd.thu", "pd.fri", "pd.sat", "pd.sun"];

const hhmm = (v, t) => {
  const [h, m] = String(v || "").split(":").map(Number);
  if (Number.isNaN(h)) return v;
  const ampm = h < 12 ? t("time.am") : t("time.pm");
  const hour = h % 12 === 0 ? 12 : h % 12;
  return m ? `${hour}:${String(m).padStart(2, "0")}${ampm}` : `${hour}${ampm}`;
};

export const daysLabel = (days, t) => {
  const d = [...(days || [])].sort((a, b) => a - b);
  if (d.length === 7) return t("qh.everyDay");
  if (d.join() === "0,1,2,3,4") return t("qh.weekdays");
  if (d.join() === "5,6") return t("qh.weekends");
  return d.map((n) => t(DAY_KEYS[n])).join(", ");
};

// A standing window — the 3-to-5 lull a restaurant wants to fill. Outside it the listing stays on
// the page and simply says when it opens.
export const QuietHoursBadge = ({ deal, className = "" }) => {
  const { t } = useLang();
  const r = deal?.recurring;
  if (!r) return null;
  const base = "inline-flex items-center gap-1 rounded-full font-bold text-[11px] px-2 py-0.5 border";
  if (r.activeNow) {
    return (
      <span data-testid={`quiet-live-badge-${deal.id}`}
        className={`${base} border-[#16a34a]/30 bg-[#e7f6ec] text-[#16a34a] dark:bg-[#16341f] ${className}`}>
        <Clock size={11} /> {t("qh.onUntil", { time: hhmm(r.end, t) })}
      </span>
    );
  }
  return (
    <span data-testid={`quiet-soon-badge-${deal.id}`}
      className={`${base} border-[#f5b942]/50 bg-[#fdf2e0] text-[#b45309] dark:bg-[#3a2f10] ${className}`}>
      <Clock size={11} /> {t("qh.starts", { time: hhmm(r.start, t) })}
    </span>
  );
};

export const QuietHoursLine = ({ deal }) => {
  const { t } = useLang();
  const r = deal?.recurring;
  if (!r) return null;
  return (
    <p className="text-sm text-muted-foreground" data-testid="quiet-hours-line">
      {t("qh.runs", { days: daysLabel(r.days, t), from: hhmm(r.start, t), to: hhmm(r.end, t) })}
    </p>
  );
};
